/* ============
 * Groups Actions
 * ============
 *
 * The actions available for the Groups module.
 */

import Vue from 'vue';
import store from '@/store';
import GroupApi from '@/api/group';
import * as types from './types';

export default {
  async findAll() {
    store.dispatch('application/startLoading');
    try {
      return await GroupApi.findAll();
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async findById({ commit }, groupId) {
    store.dispatch('application/startLoading');
    try {
      return await GroupApi.findById(groupId);
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async search({ commit }, searchParams) {
    store.dispatch('application/startLoading');
    try {
      return await GroupApi.search(searchParams).then((response) => {
        const pagination = {
          current: (searchParams.offset + searchParams.limit) / searchParams.limit,
          total: Math.ceil((response.nbGroups / searchParams.limit)),
        };
        commit(types.SET_PAGINATION, pagination);
        return response;
      });
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async create({ commit }, group) {
    store.dispatch('application/startLoading');
    try {
      return await GroupApi.create(group).then((response) => {
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.groups.create.success'),
          time: 3,
          type: 'success',
        });
        return response;
      });
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async update({ commit }, group) {
    store.dispatch('application/startLoading');
    try {
      return await GroupApi.update(group).then(() =>
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.groups.update.success'),
          time: 3,
          type: 'success',
        })
      );
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async addUserToGroup({ commit }, payload) {
    store.dispatch('application/startLoading');
    try {
      return await GroupApi.addUserToGroup(payload);
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async deleteUserFromGroup({ commit }, payload) {
    store.dispatch('application/startLoading');
    try {
      return await GroupApi.deleteUserFromGroup(payload.groupId, payload.userId).then(() =>
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.groups.deleteUserFromGroup.success'),
          time: 3,
          type: 'success',
        })
      );
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
  async destroy({ commit }, groupId) {
    store.dispatch('application/startLoading');
    try {
      return await GroupApi.destroy(groupId).then(() =>
        store.dispatch('application/displaySnackbar', {
          text: Vue.$i18n.t('store.groups.destroy.success'),
          time: 3,
          type: 'success',
        })
      );
    } catch (error) {
      store.dispatch('application/displaySnackbar', {
        text: error.message,
        time: 3,
        type: 'error',
      });
      throw error;
    } finally {
      store.dispatch('application/finishLoading');
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/settings-groups/actions.js